<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="form-group flex-1">
        <label>Explications</label>
        <input
          id="question"
          type="text"
          v-model="question"
          class="form-control"
        />
        <input type="hidden" name="questions" v-model="questions" />
      </div>
      <button
        type="button"
        @click="addQuestion"
        class="btn btn-sm btn-circle btn-icon btn-success ml-10"
      >
        <i class="fas fa-plus"></i>
      </button>
    </div>
    <div id="qst_list">
      <div class="qst" v-for="qst in qsts" :key="`question_${qst.index}`">
        <p>{{ qst.content }}</p>
        <button
          type="button"
          :data-index="qst.index"
          @click="deleteQuestion(qst.index)"
          class="btn btn-sm btn-icon btn-danger"
        >
          <i class="fas fa-trash"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      questions: [],
      qsts: [],
      question: null,
      index: 1,
    };
  },

  methods: {
    addQuestion() {
      if (this.question != "" && this.question != null) {
        this.qsts.push({
          index: this.index,
          content: this.question,
        });
        this.index += 1;
        this.questions.push(this.question);
        this.question = "";
      }
    },
    deleteQuestion(index) {
      this.qsts = this.qsts.filter((qst) => {
        return qst.index != index;
      });
      this.questions = this.qsts.map((qst) => {
        return qst.content;
      });
      this.index -= 1;
    },
  },
};
</script>

<style scoped>
#qst_list {
  height: 200px;
  overflow-y: scroll;
}

.qst {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.qst p {
  font-size: 16px;
}
.flex-1 {
  flex: 1;
}
</style>
